import { createAction, props } from '@ngrx/store';
import { User } from '../models';

export const loadUser = createAction('[User] Load');

export const userLoaded = createAction('[User] Loaded', props<{ user: User }>());
